import { cibWindows } from "@coreui/icons";
import { BOUsers } from "../models/BOUsers.model";

export class GlobalConstants{
  //Respaldo
 public static apiURL: string = 'https://servivital-001-site3.htempurl.com/';
 //testing:
 //public static apiURL: string = 'https://servivital-001-site2.htempurl.com/';
 //production:
  //public static apiURL: string = 'https://servivital-001-site4.ptempurl.com/'
 //local-testing
  //public static apiURL: string = 'https://localhost:44300/';
}

